import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import LinearProgress from "@material-ui/core/LinearProgress";
import AccountDropDown from "../../../components/dropDown/account";
import InstrumentDropDown from "../../../components/dropDown/instrument";
import {
    amountDataTableTemplate,
    numberWithCommaDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import UploadFileStance from "../../../components/uploadFile/uploadFileStance";
import PropTypes from "prop-types";


const CaptureLoanableValuesView = (props) => {

    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <HeaderScreenPresval headerTitle="Prestamista \ Captura Valores Prestables"
                                                 onExpand={props.clearFilters}
                                                 actionSearch={props.searchLoanableValues}>
                                <div className="p-grid">
                                    <div className="p-col-12 p-md-6 p-lg-5">
                                        <SubtitleLabel header="Cuenta" isBold={true}/>
                                        <AccountDropDown
                                            name="accountObj"
                                            filter="cuenta"
                                            save={props.onChangeDropdown}
                                            value={props.accountObj}
                                            loading={props.loading}
                                            placeholder="Todas las Cuentas"/>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-5">
                                        <SubtitleLabel header="Emisora" isBold={true}/>
                                        <InstrumentDropDown
                                            name="instrumentObj"
                                            filter="emisoraSerieCupon"
                                            save={props.onChangeDropdown}
                                            value={props.instrumentObj}
                                            loading={props.loading}
                                            placeholder="Todas las Emisoras"/>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-2">
                                        <br/>
                                        <Button label="Limpiar"
                                                style={{'float': 'right'}}
                                                onClick={props.clearFilters}
                                                className="p-button-secondary"/>
                                    </div>
                                </div>
                            </HeaderScreenPresval>
                        </Grid>
                        <Grid item xs={12} style={{textAlign: 'right'}}>
                            <br/>
                            <Button label="Postura Rápida"
                                    style={{'float': 'right'}}
                                    onClick={props.redirectAddPosition}
                                    className="p-button-secondary"/>
                            <UploadFileStance type={["text/csv"]}
                                              size="1000000"
                                              urlAction="/stance/lender/order/upload"
                                              className="p-button-secondary"
                                              titleHeader="Cargar archivo"
                                              titleButton="Importar"
                                              errorTypeMessage="El documento debe ser en formato .csv"
                                              errorSizeMessage="El tamaño no debe ser mayor a 1MB"
                                              instructions="Debe ser un archivo en formato CSV."
                                              loadingFunc={props.loading}
                                              action={props.searchLoanableValues}/>&nbsp;
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                responsive={true}
                                value={props.dataLoanableValues}
                                selectionMode="single"
                                onSelectionChange={props.handleSelectedRow}
                                selection={props.selectedPosition}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="cuenta" header="Cuenta" style={{textAlign: 'right'}}
                                        sortable={true}/>
                                <Column field="folio" header="Folio" style={{textAlign: 'right'}}
                                        sortable={true}/>
                                <Column field="emisora" header="Emisora" style={{textAlign: 'left'}}
                                        sortable={true}/>
                                <Column field="cantidad" header="Títulos" style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="plazo" header="Plazo" style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="tasa" header="Tasa" style={{textAlign: 'right'}}
                                        body={rateMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                                <Column field="sobreTasa" header="Sobretasa" style={{textAlign: 'right'}}
                                        body={rateMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                                <Column field="premio" header="Premio" style={{textAlign: 'right'}}
                                        body={amountDataTableTemplate} sortable={true}/>
                                <Column field="premioMin" header="Premio Mín." style={{textAlign: 'right'}}
                                        body={amountDataTableTemplate} sortable={true}/>
                                <Column header="Acciones" body={props.loanableValuesActionTemplate}
                                        style={{textAlign: 'center', width: '8em'}}/>
                            </DataTable>
                            {props.confirmationMsg}
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        </React.Fragment>
    )
};
CaptureLoanableValuesView.propTypes = {
    searchLoanableValues: PropTypes.func.isRequired,
}

export default (CaptureLoanableValuesView);
